import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaRegFile } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U3134ROLES } from "../../../U3134";
import type { U3134WorkInProgressFormRow } from "../../../U3134Service";
import { isU3134InvoicedLine } from "../../../U3134Service";

interface U3134WorkInProgressFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<Record<string, unknown>> & {
    getData: () => unknown;
    getFormState: () => U2000FormStateEnumState;
    modifyWorkInProgressLine: () => void;
  };
}

export const U3134WorkInProgressFormToolBar: React.FC<U3134WorkInProgressFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const row = formStateHandlers.getData() as unknown as U3134WorkInProgressFormRow | null;
  const isInvoiced = isU3134InvoicedLine(row);
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3134ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyWorkInProgressLine();
      },
      disabled: formState === U2000FormStateEnumState.EDIT || isInvoiced,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
